import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
	item: [],

	gettingItem: false,

	isError: false,
	errorCode: 0,
	errorMessage: null,
};

export const DashboardSlice = createSlice({
	name: 'dashboard',
	initialState,
	reducers: {

		clearAnalytics: (state, action) => {
			return { ...state, item: null, gettingItem: false};
		},

		onLoadItem: (state, action ) => {
			return {...state, item: null, gettingItem: true};
		},

		// Success
		onSuccessItem: (state, action) => {
			return {...state, item: action.payload.data, gettingItem: false};
		},

		// Errors
		onFailItem: (state, action) => {
			return {...state, item: null, gettingItem: false };
		},
	},
});

export const {
	clearAnalytics
} = DashboardSlice.actions;
